<!-- Fora do `LayoutComponent`: a classe de versão que pinta os tokens vem da
     diretiva, não do shell. Ver `AccountVersionThemeDirective`. -->
<main class="public-screen" appAccountVersionTheme>
  <div class="public-card">
    <div class="brand-bar"></div>
    <div class="public-card-body">
      <div class="logo">
        <img src="/assets/logo-smsfunnel-login.png" alt="SMS Funnel" title="SMS Funnel" />
      </div>

      <!-- Passo 1: credenciais -->
      <form
        class="public-form"
        [formGroup]="loginForm"
        (submit)="login()"
        *ngIf="step === 'credentials'"
      >
        <p class="screen-label">Acesso ao painel</p>

        <div class="form-group mt-4">
          <label for="email">Email</label>
          <input type="email" data-testid="input-email-login" class="form-control" id="email" name="email" formControlName="email" #inputEmail />
        </div>
        <div class="form-group">
          <label for="password">Senha</label>
          <input type="password" data-testid="input-password-login" class="form-control" id="password" name="password" formControlName="password">
        </div>
        <div class="form-alert form-alert-danger" *ngIf="twoFactorBlockedMessage" data-testid="alert-2fa-blocked">
          <p>
            {{ twoFactorBlockedMessage }}
            <a [href]="twoFactorSupportLink" target="_blank" data-testid="link-2fa-support">Abrir chamado no Suporte</a>.
          </p>
        </div>
        <div class="form-alert form-alert-danger" *ngIf="passwordAttemptsError">
          <p>
            Sua conta foi bloqueda por segurança, para liberar sua conta acione o suporte
            <a [href]="supportLink" target="_blank">aqui</a>.
          </p>
        </div>
        <div class="form-group d-grid">
          <button type="submit" class="btn btn-primary" [appLoadingButton]="busy" data-testid="btn-login">ENTRAR</button>
        </div>
        <div class="public-links">
          <a [routerLink]="['/password-reset']" data-testid="reset-password-link">
            Esqueci minha senha
            <i class="fa fa-chevron-right"></i>
          </a>
          <a [href]="registerLink" *ngIf="registerLink" data-testid="register-link">
            Não possuo cadastro
            <i class="fa fa-chevron-right"></i>
          </a>
        </div>
      </form>

      <!-- Passo 2: código do autenticador (CU-86ak84mj6) -->
      <form class="public-form" (submit)="verifyCode()" *ngIf="step === 'code'">
        <p class="screen-label">Verificação em duas etapas</p>

        <p class="screen-hint" *ngIf="!usingRecoveryCode">
          Abra o aplicativo autenticador e digite o código de 6 dígitos.
        </p>

        <p class="screen-hint" *ngIf="usingRecoveryCode">
          Digite um dos códigos de recuperação que você guardou quando ativou a
          verificação em duas etapas.
        </p>

        <div class="form-group mt-4" *ngIf="!usingRecoveryCode">
          <label for="twoFactorCode">Código do autenticador</label>
          <input type="text" class="form-control input-code" id="twoFactorCode" name="twoFactorCode"
            data-testid="input-2fa-code" inputmode="numeric" autocomplete="one-time-code" maxlength="6"
            [(ngModel)]="twoFactorCode" [ngModelOptions]="{standalone: true}" />
        </div>

        <div class="form-group mt-4" *ngIf="usingRecoveryCode">
          <label for="recoveryCode">Código de recuperação</label>
          <input type="text" class="form-control" id="recoveryCode" name="recoveryCode"
            data-testid="input-2fa-recovery" [(ngModel)]="recoveryCode"
            [ngModelOptions]="{standalone: true}" />
          <small class="field-hint">
            Cada código serve uma vez, e usar um encerra as sessões abertas
            desta conta.
          </small>

          <div class="form-alert form-alert-warning mt-3" role="alert" data-testid="alert-2fa-no-codes">
            <p>
              Não tem os códigos de recuperação? Só o Suporte consegue liberar o
              acesso — a verificação será zerada e você receberá uma chave nova
              para cadastrar no aplicativo.
              <a [href]="twoFactorSupportLink" target="_blank" data-testid="link-2fa-support">Falar com o Suporte</a>.
            </p>
          </div>
        </div>

        <div class="form-alert form-alert-danger" *ngIf="twoFactorError">
          <p>{{ twoFactorError }}</p>
        </div>

        <div class="form-group d-grid">
          <button type="submit" class="btn btn-primary" [appLoadingButton]="busy" data-testid="btn-2fa-verify">CONFIRMAR</button>
        </div>

        <div class="public-links">
          <a href="javascript:void(0)" (click)="toggleRecoveryCode()" data-testid="link-2fa-recovery">
            {{ usingRecoveryCode ? 'Usar o aplicativo autenticador' : 'Usar um código de recuperação' }}
            <i class="fa fa-chevron-right"></i>
          </a>
          <a href="javascript:void(0)" (click)="cancelTwoFactor()">
            Voltar
            <i class="fa fa-chevron-right"></i>
          </a>
        </div>
      </form>

    </div>
  </div>
</main>

